import React from 'react';
import './Profile.css';

const Profile = () => {
    return (
        <div className='profile'>
            <div className='profile-box'>TI</div>
            <div className='name-portion'>
                <div>Tabassum Islam</div>
                <div><p><small>Tokyo,Japan</small></p></div>
            </div>
        </div>

    );
};

export default Profile;